@if (currentChat()?.status === chatStatus.paymentRequired) {
  <div class="flex justify-center items-center text-center p-2">
    <button
      class="joii-btn-primary shadow-lg hover:scale-105 transition-transform duration-200 ease-linear"
      (click)="chatStore.openStripePaymentLink(currentChat())"
    >
      {{ priceLabel() }}
    </button>
  </div>
}
